/*eslint-disable*/
import * as gfunctions from '../../../js/generalFunctions';
CCL.heroBannerCardContainer = {
  autoload: [
    ['heroBannerCardContainerHeight', $('.c-hero-banner-cruise-manager .hero-banner-card-container').length > 0],
    ['heroBannerCardContainerHeight', $('.hero-banner-small-card-container').length > 0]
  ],
  heroBannerCardContainerHeight() {
    const heroBannerCardContainerHeight = $('.hero-banner-card-container').outerHeight();
    if ($('.hero-banner-card-container')) {
      if (gfunctions.detectmob()) {
        $('.c-hero-banner-cruise-manager').css('height', heroBannerCardContainerHeight + 201 + 'px');
      }
    }

    // Executes when complete page is fully loaded, including
    // all frames, objects and images
    $(window).on('load', () => {
      $('.c-hero-banner-cruise-manager .hero-banner-card-container').css('overflow', 'visible');
      $('.hero-banner-small-card-container').fadeIn();
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-hero-banner-cruise-manager/c-hero-banner-cruise-manager.js